module.exports = __webpack_public_path__ + "img/home.91b68a07.svg";